import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-float-label" }
const _hoisted_2 = { class: "kn-material-input-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_InputText = _resolveComponent("InputText")
  const _component_Card = _resolveComponent("Card")

  return (_openBlock(), _createBlock(_component_Card, { class: "p-m-2" }, {
    header: _withCtx(() => [
      _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--secondary p-p-0 p-m-0 p-col-12" }, {
        start: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.parameters')), 1)
        ]),
        _: 1
      })
    ]),
    content: _withCtx(() => [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.parameters, (parameter, index) => {
        return (_openBlock(), _createBlock("div", {
          key: index,
          class: "p-mt-3"
        }, [
          _createVNode("span", _hoisted_1, [
            _createVNode(_component_InputText, {
              class: "kn-material-input",
              modelValue: parameter.value,
              "onUpdate:modelValue": ($event: any) => (parameter.value = $event),
              modelModifiers: { trim: true },
              "data-test": "parameter-input"
            }, null, 8, ["modelValue", "onUpdate:modelValue"]),
            _createVNode("label", _hoisted_2, _toDisplayString(parameter.name), 1)
          ])
        ]))
      }), 128))
    ]),
    _: 1
  }))
}